import { queryOptions } from '@tanstack/react-query';
import h, { getCountry } from '../helpers/common';
import user from '../helpers/user';
import { STORE_NAME } from '@intigral/constant';
import { Mood, bgImgURLsType } from './interface/iChannelCategories';
import { KIDSMODE } from '@libs/constants';
import { container } from '@intigral/domain/lib/DataDomain';
import { IMpxService } from '@intigral/domain/lib/application/services/MpxService';
import { DI } from '@intigral/constant/config/DIContainer';
import { moodsQueryKeys } from './useMoodsQuery';

// Query options for channel categories
export const channelCategoriesQueryOptions = (mood: Mood) =>
    queryOptions({
        queryKey: moodsQueryKeys.channels(mood),
        queryFn: async () => {
            try {
                const { subscriptionGUID } = h.getStore(STORE_NAME.USER) || {};
                const country = getCountry();
                const guids = subscriptionGUID.join('|');
                const isKidsProfile = user.getProfileMode() === KIDSMODE.KID;
                const mpxService = container.resolve<IMpxService>(DI.SERVICES.IMpxService);
                const response = await mpxService.getChannelCategories(guids, country, isKidsProfile);

                if (Array.isArray(response.entries)) {
                    const channelCategories = response.entries
                        .flatMap((item: any) => (Array.isArray(item['pl1$categories']) ? item['pl1$categories'] : []))
                        .reduce((acc: string[], curr: string) => {
                            if (!acc.includes(curr)) acc.push(curr);
                            return acc;
                        }, []);

                    const contentConfig = Array.isArray(mood.data.content) ? mood.data.content : [];

                    const content = contentConfig.filter((el) => channelCategories.includes(el.filterName));
                    const transformedContent = content.map((el) => ({
                        id: el.id,
                        title: el.assetTitleKey,
                        type: el.filterName,
                        image: getBackgroundImageURL(el.backgroundImageUrls),
                        ...el,
                    }));

                    return transformedContent;
                } else {
                    return [];
                }
            } catch (error) {
                throw new Error('Failed to fetch channel categories');
            }
        },
        enabled: !!mood && !!mood.data,
        staleTime: 3 * 60 * 1000, // 3 minutes
        gcTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });

function getBackgroundImageURL(backgroundImageUrls: bgImgURLsType[]): string | null {
    const tvUrlObj = backgroundImageUrls.find((item) => item.key.toLowerCase() === 'tv');
    const tabletUrlObj = backgroundImageUrls.find((item) => item.key.toLowerCase() === 'tablet');

    return tvUrlObj ? tvUrlObj.url : tabletUrlObj ? tabletUrlObj.url : null;
}
